import { rest } from 'lodash';
import React from 'react';
import { Image } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const Logo = ({ ...rest }) => {

  const themeState = useSelector(state => state.themeState);

  return (
    <div>
      <Image
        src={themeState.themeMode === 'dark' ? '/assets/images/NX-logo-dark.svg' : '/assets/images/NX-logo-light.svg'}
        alt="Logo"
      />
    </div>
  );
};

export default Logo;
